import * as Sentry from '@sentry/react'
import { queryClient } from '@/app/queryClient'
import { clearPortalOrderDrafts } from '@/shared/lib/clearPortalOrderDrafts'

const AUTH_REDIRECT_REASON_KEY = 'auth_redirect_reason'
const AUTH_REDIRECT_FROM_KEY = 'auth_redirect_from'
const AUTH_REQUIRED_REASON = 'auth_required'
const LOGIN_AUTH_REQUIRED_URL = '/auth/login?reason=auth_required'

export type UnauthenticatedProblem = {
  type?: unknown
  status?: unknown
}

export function isUnauthenticatedProblem(body: unknown): body is UnauthenticatedProblem {
  return (
    body !== null &&
    typeof body === 'object' &&
    (body as UnauthenticatedProblem).type === '/problems/unauthenticated' &&
    (body as UnauthenticatedProblem).status === 401
  )
}

export function clearAuthenticatedClientSession(): void {
  clearPortalOrderDrafts()
  queryClient.removeQueries({ queryKey: ['auth'] })
  queryClient.removeQueries({ queryKey: ['profile'] })
  queryClient.removeQueries({ queryKey: ['brand', 'authenticated'] })
  Sentry.setUser(null)

  try {
    sessionStorage.removeItem(AUTH_REDIRECT_REASON_KEY)
    sessionStorage.removeItem(AUTH_REDIRECT_FROM_KEY)
  } catch {
    // ignore storage failures
  }
}

export function redirectToLoginAfterUnauthenticated(): void {
  if (typeof window === 'undefined') {
    return
  }

  const pathname = window.location.pathname
  // Public anonymous surfaces must not bounce to login on a probe 401 (QR hub, auth, legal).
  if (
    pathname.startsWith('/auth') ||
    pathname.startsWith('/legal/') ||
    pathname.startsWith('/r/')
  ) {
    return
  }

  const from = `${pathname}${window.location.search}`
  clearAuthenticatedClientSession()

  try {
    sessionStorage.setItem(AUTH_REDIRECT_REASON_KEY, AUTH_REQUIRED_REASON)
    sessionStorage.setItem(AUTH_REDIRECT_FROM_KEY, from)
  } catch {
    // ignore storage failures
  }

  window.location.assign(LOGIN_AUTH_REQUIRED_URL)
}
